import { render } from "./NavBarBottom.vue?vue&type=template&id=dc18ff1e&scoped=true"
import script from "./NavBarBottom.vue?vue&type=script&lang=js"
export * from "./NavBarBottom.vue?vue&type=script&lang=js"

import "./NavBarBottom.vue?vue&type=style&index=0&id=dc18ff1e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc18ff1e"]])

export default __exports__